import { h, Component } from 'preact';
import dlv from 'dlv';

import style from './style.less';

import CardHeader from '../../pieces/card-header';
import { fetchFeed } from '../../../lib/data';

import { trackingProvider, TrackingProvider, DIMENSION } from '@cube/track';

@trackingProvider({
	[DIMENSION.componentpath]: 'TopSearchesCluster'
})
export default class TopSearchesCluster extends Component {

	state = {
		loading: false,
		error: false
	};

	getAssets = (props) => {
		this.setState({
			loading: true,
			error: false
		});

		return fetchFeed({ feed: 'gen4_top_searches_foryou', ...props })
			.then( res => {
				if (dlv(res, 'cards.0.assets.0')) {
					this.setState({
						assets: res.cards[0].assets,
						loading: false,
						error: false
					});
					return;
				}
				this.setState({
					loading: false,
					error: true
				});
			})
			.catch( error => {
				this.setState({
					loading: false,
					error: true
				});
			});
	};

	getLink = (query) => {
		if (query) {
			return '/search/?context=topsearches&v=1&q=' + query;
		}
	};

	componentWillMount() {
		this.getAssets(this.props);
	}

	render({ theme, title, titleIcon, clusterClass, qeId, ...props }, { assets, loading, error }) {
		if (error || !assets || assets.length === 0) return null;

		return (
			<div class={style.topSearches}>
				<CardHeader title={title} titleIcon={titleIcon} theme={theme} />
				<div class={style.terms}>
					{ assets.map((asset, index) => (
						<TrackingProvider {...{ [DIMENSION.clickindex]: index+1 }} >
							<a href={this.getLink(asset.term)} target="_blank" rel="noopener noreferrer">
								<span class={style.number}>{ index+1 }. </span>
								<span class={style.label}>{ asset.term }</span>
							</a>
						</TrackingProvider>
					))
					}
				</div>
			</div>
		);
	}
}
